var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{class:{'box-shadow': _vm.blacklist}},[_c('router-view')],1),(_vm.showPlayRes)?_c('play-resources'):_vm._e(),(_vm.showTask)?_c('new-task'):_vm._e(),(_vm.showPointGuide)?_c('point-guide'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }